"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30667 2C3.48045 2 2 3.48045 2 5.30667V14.6933C2 16.5196 3.48045 18 5.30667 18H14.6933C16.5196 18 18 16.5196 18 14.6933V5.30667C18 3.48045 16.5196 2 14.6933 2H5.30667ZM5.62669 3.92002C4.68412 3.92002 3.92002 4.68412 3.92002 5.62669V14.48C3.92002 15.4226 4.68412 16.1867 5.62669 16.1867H14.48C15.4226 16.1867 16.1867 15.4226 16.1867 14.48V5.62669C16.1867 4.68412 15.4226 3.92002 14.48 3.92002H5.62669ZM10 12.7733C11.5317 12.7733 12.7733 11.5317 12.7733 10C12.7733 8.46834 11.5317 7.22668 10 7.22668C8.46834 7.22668 7.22668 8.46834 7.22668 10C7.22668 11.5317 8.46834 12.7733 10 12.7733ZM10 14.0533C12.2386 14.0533 14.0533 12.2386 14.0533 10C14.0533 7.76142 12.2386 5.94668 10 5.94668C7.76142 5.94668 5.94668 7.76142 5.94668 10C5.94668 12.2386 7.76142 14.0533 10 14.0533ZM14.0533 6.79998C14.5246 6.79998 14.9067 6.41793 14.9067 5.94664C14.9067 5.47536 14.5246 5.09331 14.0533 5.09331C13.5821 5.09331 13.2 5.47536 13.2 5.94664C13.2 6.41793 13.5821 6.79998 14.0533 6.79998Z",
    fill: fill
  }));
};

exports["default"] = _default;